import setUrl from 'x/setUrl.js';

import {
  refresh
} from 'x/route.js';

import removeSlash from 'x/removeSlash.js';

export default (url) => {
  url = removeSlash(url);
  setUrl(url);
  refresh(url);
};
